<template>
  <nav class="w-56 min-h-full bg-white shadow rounded p-6 flex flex-col gap-4">
    <button
      v-for="tab in tabs"
      :key="tab.value"
      @click="$emit('tab-selected', tab.value)"
      :class="['py-2 px-4 rounded text-left', activeTab === tab.value ? 'bg-primary text-white' : 'hover:bg-primary/10']"
    >
      {{ tab.label }}
    </button>
  </nav>
</template>

<script setup>
import { defineProps } from 'vue'
const props = defineProps({
  activeTab: String,
  tabs: Array
})
</script> 